import { PortalAppEnvironment } from '@nuso/portal/environments';

export const defaults: PortalAppEnvironment = {
  appName: 'Management Portal',
  envName: 'changeme',
  production: true,
  sentry: '',
  showDebug: false,
  statusPageIoEmbedUrl: 'https://wkkzjngtxqk9.statuspage.io/embed/frame', // sandbox status page

  isTestDeleteMeta: true,
  customerTestingEnabled: false,
  nocEnabled: true,
  eFaxEnabled: true,
  ordersEnabled: true,
  cdrReportingEnabled: true,
  billingEnabled: false,
  supportEnabled: true,
  liveTeamworkSupportEnabled: false,
  salesforceSupportEnabled: false,
  billableEventsEnabled: true,
  issuesEnabled: true,
  statusPageEnabled: true,
  numberMovingEnabled: true,
  bandwidthSyncingEnabled: true,
  commportalUrl: 'https://nusodss1.control.nuso.cloud',
  bridgeZoomAuthUrl: 'https://TODO.nuso.io/auth',
  useAzureDirectoryMock: false,

  supportedCustomerFeatures: [
    'reports',
    'auditing', // View Audit Event Logs,
    'simple-auto-attendant',
    'shared-voicemail',
  ],
  serviceOfferingOptions: [
    { value: 'cloud-uc', label: 'NUSO Cloud UC' },
    { value: 'nuso-sip', label: 'NUSO SIP' },
    { value: 'blue-sip', label: 'NUSO Blue SIP' },
    { value: 'ipfax', label: 'IP Fax' },
    { value: 'green-uc', label: 'NUSO Green UC' },
    { value: 'teams-dr', label: 'Teams Direct Routing' },
    { value: 'teams-oc', label: 'Teams Operator Connect' },
    { value: 'nec-uc', label: 'NEC Univerge Cloud' },
    { value: 'nec-uc-m', label: 'NEC UCaaS(m)' },
    { value: 'nec-sip', label: 'NEC SIP' },
    { value: 'sotel-sip', label: 'NUSO SIP Legacy' },
  ],

  userRoleOptions: [
    { value: 'partner' },
    { value: 'reseller' },
    { value: 'customer' },
    { value: 'customer-admin' },
    { value: 'admin' },
    { value: 'superuser' },
    { value: 'end-user' },
    { value: 'porting-admin' },
    { value: 'sales-admin' },
    { value: 'noc-admin' },
  ]
};
